import { IFilter } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteDeliverablesSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#deliverablesTable';

    url: string;
    showSiteColumn: boolean;
    showAddButton: boolean;

    editCallback: (response) => void;
    addCallback: (response) => void;

    constructor(handlerUrl: string, showSiteColumn = true, showAddButton = false){
        this.url = handlerUrl;
        this.showSiteColumn = showSiteColumn;
        this.showAddButton = showAddButton;

        this.initialize();
        this.bindEvents();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            order: [[0, 'asc']],
            orderCellsTop: true,
            columns: [
                { data:'SortOrder', title: '', className: '', visible: false },
                { data:'SiteName', title: 'Site', visible: this.showSiteColumn, className: '', orderable: false },
                { data:'DeliverableName', title: 'Deliverable', className: '', orderable: false },
                { data:'StatusName', title: 'Status', className: '', orderable: false },
                { data:'ExpectedDueDate', title: 'Due Date', className: '', orderable: false },
                { data:'CompletionDate', title: 'Completion Date', className: '', orderable: false },
                { data:'ExpirationDate', title: 'Expiration Date', className: '', orderable: false },
                {
                    data: null,
                    title: '',
                    className: 'ctms-table-col-actions',
                    orderable: false,
                    render: this.getActionColumnMarkup.bind(this)
                },
            ],
            rowCallback: (row: any, data: any) => {
                if (data.ExpectedDueDate && !data.CompletionDate) {
                    const d = new Date(data.ExpectedDueDate);
                    const t = new Date();
                    if (d < t) row.classList.add('ctms-row-overdue') ;
                }
            }
        });
    }

    bindEvents() {
        $(document).on('click', `${this.tableSelector} .ctms-table-col-actions .ctms-icon-pencil`, async (evt) => {
            if (this.editCallback) {
                const row = $(evt.target).closest('tr');
                const d = $(this.tableSelector).DataTable().row(row).data();

                this.editCallback(d);
            }
        });

        $(document).on('click', `${this.tableSelector} .ctms-table-col-actions .ctms-icon-plus`, async (evt) => {
            if (this.addCallback) {
                const row = $(evt.target).closest('tr');
                const d = $(this.tableSelector).DataTable().row(row).data();

                this.addCallback(d);
            }
        });
    }

    async loadData() {

        $('#deliverableSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        $('#deliverableSectionLoading').addClass('d-none');
    }

    private getActionColumnMarkup(data, type, row) {
        const addButton = (this.showAddButton) ? `<button title="Add" class="ml-2"><i class="ctms-icon-plus"></i></button>` : ``;
        return `<button title="Edit"><i class="ctms-icon-pencil"></i></button>${addButton}`;
    }

    triggerFilter() {

    }

}